'use client';

import React from 'react';
import { Else, If, Then } from 'react-if';

import { CreditProfileAuthStatus } from '@generated-gql/generated-types';
import { gql } from '@apollo/client';

import { Box } from '@nerdwallet/currency/components/Box';
import { CenteredContainer } from '@nerdwallet/currency/components/CenteredContainer';
import { getLogger } from '@lib/logging';
import { LoadingSpinner } from '@nerdwallet/currency/components/LoadingSpinner';

import { useQueryWithLog } from '@lib/hooks/logging-hooks';
import { TuVisibilityProvider } from '@components/transunion-flow/tu-visibility-context';

import CreditScoreActivated from './credit-score-activated/credit-score-activated';
import CreditScoreUnactivated from './credit-score-unactivated/credit-score-unactivated';

const GET_TU_AUTHENTICATION_STATUS_PROFILE_QUERY = gql`
  query getTuAuthenticationStatusProfileQuery {
    tuAuthenticationStatusProfile {
      status
    }
  }
`;

const logger = getLogger('CreditScoreWrapper');

const CreditDashboard: React.FC = () => {
  const { data, error, loading, refetch } = useQueryWithLog(
    logger,
    GET_TU_AUTHENTICATION_STATUS_PROFILE_QUERY,
  );

  const { status } = data?.tuAuthenticationStatusProfile ?? {};

  if (error) {
    return null;
  }

  return (
    <TuVisibilityProvider onLinkTransunionSuccess={refetch}>
      <If condition={loading}>
        <Then>
          <CenteredContainer>
            <Box display="flex" justifyContent="center" paddingTop="4">
              <LoadingSpinner />
            </Box>
          </CenteredContainer>
        </Then>
        <Else>
          <If condition={status === CreditProfileAuthStatus.Active}>
            <Then>
              <CreditScoreActivated />
            </Then>
            <Else>
              <CreditScoreUnactivated status={status} />
            </Else>
          </If>
        </Else>
      </If>
    </TuVisibilityProvider>
  );
};

export default CreditDashboard;
